import { render, staticRenderFns } from "./delivery_list.vue?vue&type=template&id=0765eb06&scoped=true"
import script from "./delivery_list.vue?vue&type=script&lang=js"
export * from "./delivery_list.vue?vue&type=script&lang=js"
import style0 from "./delivery_list.vue?vue&type=style&index=0&id=0765eb06&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0765eb06",
  null
  
)

export default component.exports